import { render, staticRenderFns } from "./VerificationLayout.vue?vue&type=template&id=103fec89"
import script from "./VerificationLayout.vue?vue&type=script&lang=js"
export * from "./VerificationLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports